/**
 * Types
 */
import HISTORICO_ACESSO_FIELDS from '../../consts/historico-acesso-fields';

export const HistoricoAcessoTypes = {
    RESET: 'historico-acesso/RESET',
    SET_HISTORICO_ACESSO: 'historico-acesso/SET_HISTORICO_ACESSO',
    SET_HISTORICO_ACESSO_SUCCESS: 'historico-acesso/SET_HISTORICO_ACESSO_SUCCESS',
    SET_HISTORICO_ACESSO_FAIL: 'historico-acesso/SET_HISTORICO_ACESSO_FAIL'
};

/**
 * Reducer
 */
const INITIAL_STATE = {
    [HISTORICO_ACESSO_FIELDS.VISUALIZAR_HISTORICO]: false,
    [HISTORICO_ACESSO_FIELDS.CENTRAL_ATENDIMENTO]: false,
    [HISTORICO_ACESSO_FIELDS.CHAVE_HISTORICO]: null
};

export function historicoAcessoReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case HistoricoAcessoTypes.RESET: {
            return { ...INITIAL_STATE };
        }
        case HistoricoAcessoTypes.SET_HISTORICO_ACESSO: {
            return {
                ...state,
                buscandoAcessoHistorico: true
            };
        }
        case HistoricoAcessoTypes.SET_HISTORICO_ACESSO_SUCCESS: {
            return {
                ...state,
                ...action.payload.historicoAcesso,
                buscandoAcessoHistorico: false
            };
        }
        case HistoricoAcessoTypes.SET_HISTORICO_ACESSO_FAIL: {
            return {
                ...state,
                msgErroAcessoHistorico: action.payload.error,
                buscandoAcessoHistorico: false
            };
        }
        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    reset: () => ({
        type: HistoricoAcessoTypes.RESET
    }),
    setHistoricoAcesso: (codigoAcesso, chaveSegMais, chaveBroto) => ({
        type: HistoricoAcessoTypes.SET_HISTORICO_ACESSO,
        payload: { codigoAcesso, chaveSegMais, chaveBroto }
    }),
    setHistoricoAcessoFail: (error) => ({
        type: HistoricoAcessoTypes.SET_HISTORICO_ACESSO_FAIL,
        payload: { error }
    }),
    setHistoricoAcessoSuccess: (historicoAcesso) => ({
        type: HistoricoAcessoTypes.SET_HISTORICO_ACESSO_SUCCESS,
        payload: { historicoAcesso }
    })
};
